import gql from "graphql-tag";

export default gql`
  mutation PauseProcess($status: Boolean!) {
    pauseProcess(status: $status)
  }
`;
